import {canonicalizeModuleCode, getConfiguredModuleCode, ModuleCode} from './moduleRegistry'

export const ACTIVE_MODULE_SESSION_STORAGE_KEY = 'active-module-context'

function getSessionStorage(): Storage | undefined {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : undefined
  } catch (error) {
    console.error('MODULE SESSION STORAGE ACCESS ERROR', error)
    return undefined
  }
}

export function getSessionModuleCode(): ModuleCode | undefined {
  const storage = getSessionStorage()
  return canonicalizeModuleCode(storage?.getItem(ACTIVE_MODULE_SESSION_STORAGE_KEY))
}

export function getRuntimeModuleCode(): ModuleCode | undefined {
  return getConfiguredModuleCode() || getSessionModuleCode()
}

export function setSessionModuleCode(value: string): ModuleCode | undefined {
  const code = canonicalizeModuleCode(value)
  if (!code) {
    return undefined
  }

  getSessionStorage()?.setItem(ACTIVE_MODULE_SESSION_STORAGE_KEY, code)
  return code
}

export function clearSessionModuleCode() {
  getSessionStorage()?.removeItem(ACTIVE_MODULE_SESSION_STORAGE_KEY)
}

